import React from "react";
import InitSession, { logout } from "../../session.initialize";
import {setupAxiosToken, setupXUserId} from "../../_helpers/http.helper";
import * as urlHelper from "../../_helpers/url.format.server.helper";
import AxiosClient from "../../_helpers/http.helper";
import config from '../../config';
import { ROLE_PERMISSIONS } from '../constants/permissionsConstants';

const AuthContext = React.createContext();

export class AuthProvider extends React.Component {
    state = {
        isLoggedIn: false,
        userProfile: null
    };

    setUserProfile = (userProfile) => {
        this.setState({userProfile});
    };

    setLoginStatus = (status) => {
        this.setState({
            isLoggedIn: status
        });
    };

    componentDidMount() {
        InitSession(token => {
            setupAxiosToken(token);
            this.validateProfile(token, (profile => {
                this.setUserProfile(profile);
                this.setLoginStatus(true);
                this.renderNavBar(profile);
            }));
        });
    }

    validateProfile = (token, callback) => {
        const failureRedirectUrl = this.getLoginFailRedirectURL();
        const url = urlHelper.formatUrl(
            config.identity.baseUrl,
            config.identity.routes.getUserProfile, {});
        AxiosClient.get(url, {headers: {'X-Authorization': token}}).then(profile => {
            const allowedRoles = ['Project Specialist', 'LSA', 'Sales Rep'];
            let isValidUser = false;
            setupXUserId(profile.data.id);
           
            profile.data.userRoles.forEach(role => {
                if (allowedRoles.includes(role)) {
                    isValidUser = true;
                    profile.data.permissions.push(...ROLE_PERMISSIONS[role.replace(' ','_').toLowerCase()]);
                }
            });
            if (!isValidUser) {
                window.location.replace(failureRedirectUrl);
            }
            return callback(profile.data);
        })
            .catch(function (error) {
                if (process.env.NODE_ENV !== "development") {
                    if (error.status === 401) {
                        window.location.replace(failureRedirectUrl);
                    }
                }
            });
    };

    getLoginFailRedirectURL = () => {
        return window.location.origin + "/admintool";
    };

    renderNavBar = profile => {
        var element = document.getElementById("header-container");
        var config = {
            session: "Session",
            user: { givenName: profile.username },
            onLogout: logout,
            mode: "Basic",
            consoleBaseUrl: window.location.origin + "/admintool",
            links: {
                home: "{consoleBaseUrl}/",
                myAccount: "",
                termsOfUse: "",
                privacyPolicy: ""
            }
        };

        document.dispatchEvent(
            new CustomEvent("o.DOMContentLoaded", {
                bubbles: true,
                detail: {
                    element: element,
                    config: config
                }
            })
        );
    };

    render() {
        return (
            <AuthContext.Provider value={{...this.state}}>
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

export const AuthConsumer = AuthContext.Consumer;



// WEBPACK FOOTER //
// ./src/components/context/AuthContext.js